import React from 'react';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { navigationGroups } from '../../config/navigationGroups';

export function DesktopNavigation() {
  return (
    <NavigationMenu.Root className="hidden lg:flex">
      <NavigationMenu.List className="flex items-center gap-1">
        {navigationGroups.map((group) => (
          <NavigationMenu.Item key={group.label}>
            <NavigationMenu.Trigger
              className={cn(
                "group inline-flex h-9 w-max items-center justify-center rounded-md bg-transparent px-4 py-2 text-sm font-medium",
                "text-gray-300 hover:text-white hover:bg-white/10 transition-colors",
                "focus:outline-none focus-visible:ring-1 focus-visible:ring-white disabled:pointer-events-none disabled:opacity-50"
              )}
            >
              {group.label}
            </NavigationMenu.Trigger>
            <NavigationMenu.Content
              className={cn(
                "absolute left-0 top-0 w-full sm:w-auto",
                "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out",
                "data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out",
                "data-[motion=from-end]:slide-in-from-right-52",
                "data-[motion=from-start]:slide-in-from-left-52",
                "data-[motion=to-end]:slide-out-to-right-52",
                "data-[motion=to-start]:slide-out-to-left-52"
              )}
            >
              <div className="w-full sm:w-[400px] bg-gray-900/95 backdrop-blur-xl p-4 border border-white/10 rounded-xl shadow-lg">
                <ul className="grid gap-3">
                  {group.items.map((item) => (
                    <li key={item.href}>
                      <Link
                        to={item.href}
                        className="flex items-center gap-3 p-3 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
                      >
                        <item.icon className="h-5 w-5 flex-shrink-0" />
                        <div>
                          <div className="text-sm font-medium">{item.label}</div>
                          {item.description && (
                            <div className="text-xs text-gray-400 line-clamp-1">
                              {item.description}
                            </div>
                          )}
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </NavigationMenu.Content>
          </NavigationMenu.Item>
        ))}
      </NavigationMenu.List>
    </NavigationMenu.Root>
  );
}